import  { useQuery } from '@tanstack/react-query';
import { TtService } from '../../services/generatedApi';

const useSingleTTNews = (newsId: string) => {
    return useQuery(
        ["singleTTNews", newsId],
        () => TtService.ttGetSingleTtNews(newsId).then((response) => response)
    );
}

export default useSingleTTNews